import Categories from '~/graphql/queries/getCategories.graphql';

export const useCategoryFilter = async(
    category: Readonly<MaybeRefOrGetter<string>>,
    label: Readonly<MaybeRefOrGetter<string>>,
) => {
    const { variables: defaultGqlVariables } = useCraftGraphql();

    const variables = computed(() => {
        return {
            site: defaultGqlVariables.site,
            group: toValue(category)
        };
    });

    const { data, pending } = await useLazyAsyncQuery({
        query: Categories,
        variables
    });

    const options = computed(() => {
        const cats = data.value?.categories?.map(({ id, title, slug }) => {
            return {
                id,
                label: title,
                value: slug
            };
        });

        if (toValue(label)) {
            cats?.unshift({ label: toValue(label), value: '' });
        }

        return cats;
    });

    return {
        variables,
        data,
        pending,
        options
    };
};
